import { Card, CardBody, Row, Col } from "reactstrap"
import InitialClientSearch from "./visits/InitialClientSearch"
import RecentlyAddedPersons from "./visits/RecentlyAddedPersons"
import QuickActions from "./visits/QuickActions"

const IndexCRM = () => {
  return (
    <>
      <Row>
        <Col sm="6">
          <Card>
            <CardBody>
              <InitialClientSearch />
            </CardBody>
          </Card>
        </Col>
        <Col sm="6">
          <Card>
            <CardBody>
              <QuickActions />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <RecentlyAddedPersons />
    </>
  )
}

export default IndexCRM
